import { Card } from '@cocoonspace/ui/components/card'
import { Skeleton } from '@cocoonspace/ui/components/skeleton'

export const LoadingCard = () => (
	<Card className='flex w-full flex-col gap-0 divide-x divide-y overflow-hidden p-0 md:min-h-[340px] md:flex-row md:divide-x md:divide-y-0'>
		<div className='flex w-full flex-1 flex-col gap-4 p-4 md:w-[300px]'>
			<Skeleton className='h-[21px] w-[87px]' />
			<Skeleton className='h-[21px] w-[220px]' />

			<div className='flex flex-col gap-2'>
				<Skeleton className='h-[16px] w-[180px]' />
				<Skeleton className='h-[16px] w-[220px]' />
				<Skeleton className='h-[16px] w-[120px]' />
			</div>

			<div className='mt-auto flex flex-col gap-2'>
				<Skeleton className='h-[14px] w-[180px]' />
				<Skeleton className='h-[14px] w-[80px]' />
			</div>
		</div>

		<div className='flex flex-1 flex-col gap-4 p-4 md:w-[365px]'>
			<div className='flex w-full items-center justify-between gap-2 py-4'>
				<Skeleton className='size-[20px] rounded-full' />
				<Skeleton className='h-[14px] w-[150px]' />
				<Skeleton className='size-[20px] rounded-full' />
			</div>

			<div className='grid w-full grid-cols-7 gap-2'>
				{Array.from({ length: 28 + 7 + 4 }).map((_, index) => (
					<Skeleton
						key={index}
						className='size-[30px] rounded-full'
					/>
				))}
			</div>
		</div>

		<div className='flex flex-1 flex-col items-center justify-center gap-2 p-4 md:min-w-[340px]'>
			<Skeleton className='h-[14px] w-[140px]' />
		</div>
	</Card>
)
